import { defineStore } from 'pinia';
import OpendataGroup from "@/api/models/opendata-group.model";
import OpendataDataset from "@/api/models/opendata-dataset.model";
import OpendataService from "@/api/services/opendata.service";
import OpendataResource from "@/api/models/opendata-resource.model";
import OpendataFaq from "@/api/models/opendata-faq.model";
import OpendataTag from "@/api/models/opendata-tag.model";
import {PageRequest} from "@/api/utils/page-request";

const opendataService = new OpendataService();

export const useOpendataStore = defineStore('opendataStore',{
  state: () => ({
    groups: Array<OpendataGroup>(),
    datasets: Array<OpendataDataset>(),
    resources: Array<OpendataResource>(),
    dataset: new OpendataDataset(),
    faqs: Array<OpendataFaq>(),
    tags: Array<OpendataTag>(),
    formats: Array<OpendataDataset>(),
    recents: Array<OpendataDataset>(),
    populars: Array<OpendataDataset>(),
    groupSumm: Array<OpendataGroup>()
  }),
  actions: {
    async getGroups() {
      this.groups = await opendataService.getGroups();
    },
    async getDatasets() {
      this.datasets = await opendataService.getDatasets();
    },
    async getDataset(id: number) {
      this.dataset = await opendataService.getDataset(id);
    },
    async getResources(dsid: number) {
      this.resources = await opendataService.getResources(dsid);
    },
    async getFaqs() {
      this.faqs = await opendataService.getFaqs();
    },
    async getTagSummary() {
      this.tags = await opendataService.getTagSummary();
    },
    async getFormatSummary() {
      this.formats = await opendataService.getFormatSummary();
    },
    async getGroupSummary() {
      this.groupSumm = await opendataService.getGroupSummary();
    },
    async updateView(id: number) {
      await opendataService.updateDatasetView(id);
    },
    async getRecentPopular(type: string | null, recentPage: PageRequest, popularPage: PageRequest) {
      if(type === "recent") {
        this.recents = await opendataService.getRecentPopularSidebar(type, recentPage);
      } else if(type === "popular") {
        this.populars = await opendataService.getRecentPopularSidebar(type, popularPage);
      } else {
        this.recents = await opendataService.getRecentPopularSidebar("recent", recentPage);
        this.populars = await opendataService.getRecentPopularSidebar("popular", popularPage);
      }
    }
  }
});
